export default "__VITE_ASSET__CdqQYcnl__"